<div>{{this.text}}</div>
<div class="no-access-gutter">
  <a class="return-to-site" {{action "skip"}} role="button">
    {{i18n "wizard.return_to_site" siteName=this.siteName}}
  </a>
  {{#if this.showLoginButton}}
    <DButton
      class="btn-primary btn-small login-button"
      @action={{action "showLogin"}}
      @label="log_in"
      @icon="user"
    />
  {{/if}}
</div>